export default __webpack_public_path__ + "static/media/re.28810a3f.png";